const projectsPageTitles = {
  default: {
    title: 'Delegate tasks to those who enjoy them',
    subtitle: 'Check out the projects our students have done for companies in the USA and beyond',
    urlId: 'web-dev',
  },
  webDev: {
    title: 'Check out the web development projects our students have done so far',
    subtitle: '',
    urlId: 'web-dev',
  },
  dataAnalysis: {
    title: 'Check out the data analysis  projects our students have done so far',
    subtitle: '',
    urlId: 'data-analysis',
  },
  dataScience: {
    title: 'Check out the data science  projects our students have done so far',
    subtitle: '',
    urlId: 'data-science',
  },
};

export default projectsPageTitles;
